// hooks/useTyping.js
export function useTyping({
  socket,
  selectedItem,
  currentUser,
  typingUsers,
  groupTyping,
  typingTimeoutRef,
  myChatId,
  findUsernameByChatId,
  setInput,
}) {
  const handleInput = (e) => {
    const value = e.target.value;
    setInput(value);

    if (!selectedItem || !socket || !currentUser) return;

    const chatId = currentUser.chatInfo?.[0]?.chatId;

    if (selectedItem.type === "user") {
      socket.emit("typing", {
        senderChatId: chatId,
        recipientChatId: selectedItem.chatId,
      });

      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }

      typingTimeoutRef.current = setTimeout(() => {
        socket.emit("stop-typing", {
          senderChatId: chatId,
          recipientChatId: selectedItem.chatId,
        });
      }, 1000);
    } else {
      socket.emit("group-typing", {
        groupId: selectedItem.groupId,
        chatId,
      });

      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }

      typingTimeoutRef.current = setTimeout(() => {
        socket.emit("group-stop-typing", {
          groupId: selectedItem.groupId,
          chatId,
        });
      }, 1000);
    }
  };

 const renderTypingForSelected = () => {
  if (!selectedItem) return null;

  // 🛡 hard guard
  if (typeof findUsernameByChatId !== "function") return null;

  if (selectedItem.type === "group") {
    const arr = (groupTyping[selectedItem.groupId] || []).filter(
      (id) => id?.toString() !== myChatId
    );

    if (arr.length === 0) return null;

    const name = findUsernameByChatId(arr[0]) || "Someone";
    return `${name} is typing…`;
  }

  if (
    Array.isArray(typingUsers) &&
    typingUsers.includes(selectedItem.chatId?.toString())
  ) {
    return `${selectedItem.username} is typing…`;
  }

  return null;
};


  return { handleInput, renderTypingForSelected };
}
